import { render, staticRenderFns } from "./DialogFormatV2.vue?vue&type=template&id=4312a5c6&lang=pug"
import script from "./DialogFormatV2.vue?vue&type=script&lang=js"
export * from "./DialogFormatV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports